/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/controllers/publishedReportController.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:41 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Fri Dec 14 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */

class publishReportController {
    // @ngInject
    constructor($scope, $rootScope, authService, localStorageService, $state, $mdDialog) {
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Publish Reports"

            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        let active_year = localStorageService.get('academic_year')
        function findPredecessor(records, targetYear) {
            for (let i = 1; i < records.length; i++) {
                if (records[i].year === targetYear) {
                    return records[i - 1];
                }
            }
            return null; // Return null if no predecessor is found
        }
        let self = this
        self.permissions = {}
        function checkPrivileges(feature_privileges) {
            let ex = _.find(feature_privileges, function (oneP) {
                return oneP.name == "Publish Reports"
            })
            if (ex && ex.privilege) {
                let priviegeEx = _.find(ex.privilege, function (oneP) {
                    return oneP.name == "Create" &&
                        oneP.status == true
                })
                if (priviegeEx) {
                    self.permissions.Create = true
                }
            }
            console.log(self.permissions)
        }

        let school_id = localStorageService.get('school_id')
        let user_id = localStorageService.get('user_id')
        var yearRcSelected = localStorageService.get('yearRcSelected')
        var feature_privileges = localStorageService.get('feature_privileges')
        checkPrivileges(feature_privileges)


        authService.callAPI("/v0/school/details/" + school_id, "GET", {}, function (response) {
            try {
                self.scData = response.result.data.details[0].academic_year
                let immediatePrevYear = findPredecessor(response.result.data.details[0].academic_year,
                    active_year
                )
                let other_old_years = []
                if (immediatePrevYear) {
                    let olds = [active_year, immediatePrevYear.year]
                    try {
                        for (let index = 0; index < self.scData.length; index++) {
                            let element = self.scData[index];
                            try {
                                if (olds.indexOf(element.year) === -1) {
                                    other_old_years.push(
                                        element
                                    )
                                }
                            } catch (e2) {
                                console.log(e2)
                            }
                        }
                    } catch (e1) {
                        console.log(e1)
                    }
                }
                console.log(other_old_years, "??????????")
                self.other_old_years = other_old_years.map(y => y.year);
                self.isOtherOldYear = function (year) {
                    return self.other_old_years && self.other_old_years.includes(year);
                };                
                let acdYear = _.find(self.scData, function (oneY) {
                    return oneY.status == 'active'
                })
                if (acdYear) {
                    if (yearRcSelected) {
                        self.selected_year = yearRcSelected
                    } else {
                        self.selected_year = acdYear.year
                    }
                }
                $scope.getSelectedFeature(true, self.selected_year)
                // $scope.loading = false
                $scope.$apply()
            } catch (ex) {
                console.log(ex);
            }
        })

        $scope.keys = []
        $scope.resultData = []
        $scope.gap = 10;
        self.noAction = false
        $scope.loading = true
        $scope.filteredItems = [];
        $scope.groupedItems = [];
        $scope.values = []
        $scope.isLoaded = true
        $scope.isViewFilter = false
        $scope.filterObj = {}
        $scope.searchKey;
        let activeAcd_only = localStorageService.get('activeAcdYear')
        // $scope.selectedFeature = SITE_URL + "reportCardDataSet";
        // $scope.applicationFeature = [{
        //     _id: 'Report Card',
        //     name: 'ChatGroup',
        //     api_endpoints: $scope.selectedFeature,
        //     filters: []
        // }]
        // $scope.applicationFeature = _.sortBy($scope.applicationFeature, 'name')
        $scope.savedFilterArr = []
        $scope.templateName = undefined


        $scope.fetchSavedFilter = function () {
            let send = {
                school_id : school_id,
                myUserId : user_id
            }
            authService.callAPI("/v0/reportcards/publish/fetchsave" , "POST", {
                args : send
            }, function (response) {
                try {
                    console.log(response);
                    $scope.savedFilterArr = response.result.data.details.response;
                    _.defer(function () { $scope.$apply(); });
                } catch (ex) {
                    console.log(ex);
                }
            })
        }

        $scope.selectedCls = function (column) {
            let vale = $scope.sort.column && 'sort-' + $scope.sort.descending;
            return column == $scope.sort.column && 'sort-' + $scope.sort.descending;
        };

        $scope.changeSorting = function (column) {
            var sort = $scope.sort;
            if (sort.column == column) {
                sort.descending = !sort.descending;
            } else {
                sort.column = column;
                sort.descending = false;
            }
        };
        self.listRcWithSelectedYear = (selected_year) => {

            if (selected_year) {
                localStorageService.set({
                    yearRcSelected: selected_year
                })
            }
            self.selected_year = selected_year
            $scope.loading = true
            $scope.getSelectedFeature(false, selected_year)
        }
        function makedateString(db_value){
            if(!db_value || db_value == "NA"){
                return db_value
            }
            let date = new Date(db_value)
            let str = date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear()
            return str
        }
        function setDateOrder(){
            try{
                let fields = ['generated_date', "sent_for_approval_date", "approved_date"]
                let values = $scope.values
                for(let v = 0; v < values.length; v++){
                    if(fields.indexOf(values[v].key) !== -1){
                        let date_as_strings = values[v].value
                        let dates = [], redef_dates = [], _NA_exists = false
                        for(let s = 0; s < date_as_strings.length; s++){
                            if(date_as_strings[s]){
                                if(date_as_strings[s].name != "NA"){
                                    let split_str = date_as_strings[s].name.split("-")
                                    let date_str = split_str[2] + "-" + split_str[1] + "-" + split_str[0] + " 00:01:01"
                                    let one_ = new Date(date_str)
                                    let obj = {
                                        name : one_,
                                        is_selected : date_as_strings[s].is_selected
                                    }
                                    dates.push(obj)
                                }else{
                                    _NA_exists = true
                                }
                            }
                        }
                        dates.sort(function(a,b){
                            // Turn your strings into dates, and then subtract them
                            // to get a value that is either negative, positive, or zero.
                            return new Date(b.name) - new Date(a.name);
                        });
                        for(let d = 0; d < dates.length; d++){
                            let date = dates[d].name
                            let str = date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear()
                            redef_dates.push({
                                name : str,
                                is_selected : dates[d].is_selected
                            })
                        }
                        if(_NA_exists){
                            redef_dates.push({
                                name : "NA", is_selected : true
                            })
                        }
                        if(redef_dates && redef_dates.length){
                            values[v].value = redef_dates
                        }
                    }
                }
            }catch(e){
                console.log(e)
            }
        }
        $scope.getSelectedFeature = function (initialLoad, passedYear) {
            $scope.fetchSavedFilter();
            let schoolObj = {
                "school_id": school_id
            }
            schoolObj['academic_year'] = passedYear
            schoolObj['user_id'] = user_id
            let requestBody = {
                args: schoolObj
            }
            try {
                $scope.loading = true
                $scope.originalResultData = []
                authService.callAPI("/v0/reportcards/published/main", "POST", requestBody, function (response) {
                    try {
                        let resultObj = response.result.data.details
                        for(let i = 0; i < resultObj.length; i++){
                            resultObj[i]['generated_date'] = makedateString(resultObj[i]['generated_date'])
                            // resultObj[i]['sent_for_approval_date'] = makedateString(resultObj[i]['sent_for_approval_date'])
                            // resultObj[i]['approved_date'] = makedateString(resultObj[i]['approved_date'])
                        }
                        $scope.originalResultData = resultObj
                        $scope.templateFilter = []
                        if ($scope.originalResultData.length) {
                            $scope.header = _.without(Object.keys($scope.originalResultData[0]), "_id");
                            $scope.keys = _.without(Object.keys($scope.originalResultData[0]), "_id");
                            _.each($scope.header, function (data, key) {
                                $scope.templateFilter.push({
                                    key: $scope.keys[key],
                                    label: $scope.header[key]
                                })
                            })
                            $scope.resultData = $scope.originalResultData
                            $scope.totalItems = $scope.resultData.length;
                            $scope.search()
                            $scope.isLoaded = true
                            $scope.sort = {
                                column: $scope.header[0],
                                descending: false
                            };
                            $scope.viewFilters(false);
                        } else {
                            $scope.templateFilter = []
                            $scope.header = undefined
                            $scope.keys = undefined
                            $scope.resultData = undefined
                            // $scope.totalItems = undefined
                            $scope.isViewFilter = undefined
                            $scope.filterObj = {}
                            $scope.filteredItems = [];
                            $scope.groupedItems = [];
                            $scope.values = []
                            $scope.totalItems = []
                            $scope.isLoaded = false
                            $scope.pagedItems = [];
                        }
                        if ($scope.isDataObject(resultObj)) {
                            $scope.status = "success";
                        } else {
                            $scope.status = "fail";
                        }
                        console.log(passedYear + '!= ' + activeAcd_only)
                        // Toggles the 'Publish reports' button
                        try {
                            // Set of years the button 'Publish reports' should show when selecting the year
                            let Allowed_years_to_publish = new Set(['2026-2027','2025-2026','2024-2025', '2023-2024'])
                            if (Allowed_years_to_publish.has(passedYear)) {
                                self.noAction = true
                            } else {
                                self.noAction = false
                            }
                        } catch (error) {
                            // this is the fall back code(legacy code) in case the above logic doesnt work
                            if (passedYear != activeAcd_only) {
                                self.noAction = false
                            } else {
                                self.noAction = true
                            }
                        }
                        // setDateOrder()
                    } catch (error) {
                        console.log(error)
                        $scope.status = "fail";
                    }
                    $scope.loading = false
                    _.defer(function () { $scope.$apply(); });;

                    try {
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        });
                    } catch (scroll_error) {
                        console.log(scroll_error);
                    }
                })
            } catch (ex) {
                $scope.status = "fail";
            }

        }

        $scope.exportCSVData = function () {
            let nameObj = _.find($scope.applicationFeature, function (dt) {
                return dt.api_endpoints === $scope.selectedFeature
            })
            csvCovertor($scope.resultData, nameObj._id, true);
            //JSONToCSVConvertor($scope.obj, nameObj._id, true);
        }

        function fetchValues(keys, value) {
            let name, ids, arr = [];

            if (keys.type != undefined && keys.type != 'bool') {
                ids = _.compact(_.uniq(_.pluck($scope.originalResultData, keys.key)))
            } else {
                ids = _.compact(_.uniq(_.pluck($scope.originalResultData, keys.key)))
            }
            _.each(ids, function (dat) {
                if (value) {
                    let filterObj = JSON.parse($scope.selectedFilter).fields;
                    if (_.contains(filterObj[keys.key], dat)) {
                        arr.push({
                            'name': dat,
                            'is_selected': true
                        })
                    } else {
                        arr.push({
                            'name': dat,
                            'is_selected': false
                        })
                    }
                } else {
                    arr.push({
                        'name': dat,
                        'is_selected': true
                    })
                }
            })
            return arr
        }
        $scope.viewFilters = function (value) {
            $scope.refreshFilter()
            $scope.values = []

            if (!value) {
                $scope.selectedFilterToShow = []
                $scope.chipsFilter = $scope.templateFilter

                //To re assign if user dynamically remove any column field.
                $scope.header = _.pluck($scope.chipsFilter, "key");
                $scope.keys = _.pluck($scope.chipsFilter, "key");

                _.each($scope.chipsFilter, function (data) {
                    data._lowerkey = data.key.toLowerCase();
                    data._lowerlabel = data.label.toLowerCase();
                    $scope.selectedFilterToShow.push(data)
                })
            }

            let filters = $scope.templateFilter;
            let totalDataCount = $scope.originalResultData.length
            let count = 1
            if (totalDataCount <= 1000) {
                count = 1
            } else {
                count = Math.ceil(totalDataCount / 1000)
            }

            for (var i = 0; i < count; i++) {
                if (i == 0) {
                    _.each(filters, function (data) {
                        let result = fetchValues(data, value)
                        $scope.values.push({
                            key: data.key,
                            label: data.label,
                            value: result,
                            selected_text: ""
                        });
                    })
                } else {
                    _.each(filters, function (data) {
                        let result = fetchValues(data, value)
                        let requiredIndex = -1;
                        _.each($scope.values, function (dt, key) {
                            if (dt.key === data.key) {
                                requiredIndex = key
                                dt.value.concat(result)
                            }
                        })
                    })
                }

                if (i === (count - 1)) {
                    $scope.filterObj = {}
                    $scope.selectedObj = {}
                    _.each($scope.values, function (pt) {
                        let obj = _.filter(pt.value, function (ft) {
                            return ft.is_selected == true
                        })
                        let names = _.pluck(obj, "name")
                        $scope.selectedObj[pt.key] = names
                        pt.selected_text = "All"
                        pt.value = _.sortBy(pt.value, 'name');
                    })
                    $scope.columnFilterResult()
                }
            }
        }

        $scope.showFilters = function () {
            $scope.isViewFilter ? $scope.isViewFilter = false : $scope.isViewFilter = true
        }

        $scope.clearSearchTerm = function () {
            $scope.searchKey = '';
        };

        $scope.getSelectedText = function (key) {
            let result = ""
            if ($scope.selectedObj[key] != undefined && $scope.selectedObj[key].length > 0) {
                return $scope.selectedObj[key][0]
            } else {
                return "all"
            }
        }

        $scope.toggleDropdown = function (data) {
            if (data != undefined) {
                _.each($scope.values, function (dt) {
                    if (data.key == dt.key) {
                        dt.open = !dt.open
                    } else {
                        dt.open = false
                    }
                })
            }
        }

        $scope.columnFilterResult = function () {
            _.each($scope.values, function (val) {
                _.each(val.value, function (key, index) {
                    if (!_.contains($scope.selectedObj[val.key], key.name)) {
                        key.is_selected = false
                    } else {
                        key.is_selected = true
                    }
                })
            })
            let selectedAllCount = 0
            let selectedCustomCount = 0
            _.each($scope.values, function (val) {
                let nonSelecteditems = _.filter(val.value, function (data) {
                    return data.is_selected === false
                })
                if (nonSelecteditems.length === 0) {
                    val.selected_text = "All"
                    selectedAllCount++
                } else {
                    val.selected_text = "Custom"
                    selectedCustomCount++
                }
            })
            $scope.chatData = []
            let allKeys = [];
            if (selectedCustomCount > 0) {
                allKeys = _.keys($scope.selectedObj)
                let customKeys = _.filter($scope.values, function (val) {
                    return val.selected_text === "Custom"
                })
                let customKey = _.pluck(customKeys, "key")
                allKeys = customKey;
                let selectedValueCount = 0
                _.each(allKeys, function (key) {
                    if ($scope.selectedObj[key] !== undefined && $scope.selectedObj[key].length > 0) {
                        selectedValueCount++
                    }
                })
                if (selectedValueCount == allKeys.length) {
                    _.each(allKeys, function (ch, pKey) {
                        if ($scope.selectedObj[ch] !== undefined && $scope.selectedObj[ch].length > 0) {
                            if ($scope.selectedObj[ch].length == 1) {
                                let searchObj = {}
                                searchObj[ch] = $scope.selectedObj[ch][0]
                                if ($scope.chatData.length === 0) {
                                    $scope.chatData = _.where($scope.originalResultData, searchObj)
                                } else {
                                    if (pKey == 0) {
                                        $scope.chatData = _.where($scope.originalResultData, searchObj)
                                    } else {
                                        $scope.chatData = _.where($scope.chatData, searchObj)
                                    }
                                }
                            } else {
                                let chatData = []
                                for (var i = 0; i < $scope.selectedObj[ch].length; i++) {
                                    let searchObj = {}
                                    searchObj[ch] = $scope.selectedObj[ch][i]
                                    if (chatData.length === 0) {
                                        if (pKey == 0) {
                                            $scope.chatData = _.where($scope.originalResultData, searchObj)
                                            chatData = _.where($scope.originalResultData, searchObj)
                                        } else {
                                            chatData = _.where($scope.chatData, searchObj);
                                        }
                                        if (i == $scope.selectedObj[ch].length - 1) {
                                            $scope.chatData = chatData
                                        }
                                    } else {
                                        let resultArray;
                                        if (pKey == 0) {
                                            resultArray = _.where($scope.originalResultData, searchObj)
                                        } else {
                                            resultArray = _.where($scope.chatData, searchObj)
                                        }
                                        if (i == 0) {
                                            chatData = resultArray
                                        } else {
                                            _.each(resultArray, function (data) {
                                                chatData.push(data)
                                            })
                                        }
                                        if (i == $scope.selectedObj[ch].length - 1) {
                                            $scope.chatData = chatData
                                        }
                                    }
                                }
                            }
                        } else {
                            $scope.chatData = []
                        }
                    })
                } else {
                    $scope.chatData = []
                }
            }
            if (allKeys.length > 0) {
                $scope.resultData = $scope.chatData
            } else {
                $scope.resultData = $scope.originalResultData
            }
            $scope.totalItems = $scope.resultData.length;
            $scope.search()
        }

        $scope.keyDownHandler = function (event) {
            if (event.target != null && event.target.offsetParent != null) {
                if (event.target.id === "btnSelect" || event.target.offsetParent.id === "lstItem") {
                    return
                } else {
                    _.each($scope.values, function (dt) {
                        dt.open = false
                    })
                }
            }
        }

        $scope.setFilterObj = function (data, key) {
            if (!data.is_selected) {
                let obj = _.reject($scope.selectedObj[key], function (kt) {
                    return kt === data.name
                })
                $scope.selectedObj[key] = obj
            } else {
                if (!_.contains($scope.selectedObj[key], data.name)) {
                    if ($scope.selectedObj[key] != undefined) {
                        $scope.selectedObj[key].push(data.name)
                    } else {
                        $scope.selectedObj[key] = []
                        $scope.selectedObj[key].push(data.name)
                    }
                }
            }
            $scope.filterObj[key] = data.name
        }

        $scope.refreshFilter = function () {
            $scope.filterObj = {}
            $scope.selectedObj = {}
            _.each($scope.values, function (pt) {
                $scope.setAllData(pt.value, pt.key)
            })
            $scope.columnFilterResult()
        }

        $scope.isDataString = function (data) {
            return _.isString(data)
        }
        $scope.isDataBoolean = function (data) {
            return _.isBoolean(data)
        }
        $scope.isDataNumber = function (data) {
            return _.isNumber(data)
        }
        $scope.isDataArray = function (data) {
            return _.isArray(data)
        }
        $scope.isDataObject = function (data) {
            return _.isObject(data)
        }
        $scope.isArrayOfDataObject = function (data) {
            let type = 'text'
            if (_.isString(data) || _.isBoolean(data) || _.isNumber(data)) {
                type = 'text'
            } else if (_.isObject(data)) {
                let obj = data[0].name
                if (_.isObject(obj)) {
                    type = 'array_of_object'
                } else {
                    type = 'text'
                }
            }
            return type
        }
        $scope.isId = function (data) {
            let isIdExist = false
            if (_.isString(data) && data.indexOf("_id") >= 0) {
                isIdExist = true
            }
            return isIdExist
        }

        $scope.keyReplace = function (data) {
            //let isIdExist = false
            let str = data.replace(/_/g, ' ');
            return str; //.toUpperCase()
        }



        $scope.currentPage = 0;
        $scope.numPerPage = 10;
        $scope.itemsPerPage = 10

        $scope.paginate = function (value) {
            var begin, end, index;
            begin = ($scope.currentPage - 1) * $scope.numPerPage;
            end = begin + $scope.numPerPage;
            index = $scope.resultData.indexOf(value);
            return (begin <= index && index < end);
        };

        $scope.setAllData = function (data, key) {
            _.each(data, function (dt) {
                dt.is_selected = true
            })
            _.each($scope.values, function (val) {
                let nonSelecteditems = _.filter(val.value, function (data) {
                    return data.is_selected === false
                })
                if (nonSelecteditems.length === 0) {
                    val.selected_text = "All"
                } else {
                    val.selected_text = "Custom"
                }
            })
            let keyBasedValues = _.pluck(data, 'name');
            $scope.selectedObj[key] = keyBasedValues
            $scope.columnFilterResult();
        }

        $scope.unSetAllData = function (data, key) {
            _.each(data, function (dt) {
                dt.is_selected = false
            })
            _.each($scope.values, function (val) {
                let nonSelecteditems = _.filter(val.value, function (data) {
                    return data.is_selected === false
                })
                if (nonSelecteditems.length === 0) {
                    val.selected_text = "All"
                } else {
                    val.selected_text = "Custom"
                }
            })
            $scope.selectedObj[key] = []
            $scope.columnFilterResult();
        }

        $scope.prevPage = function () {
            if ($scope.currentPage > 0) {
                $scope.currentPage--;
            }
        };

        $scope.nextPage = function () {
            if ($scope.currentPage < ($scope.totalItems / 10) - 1) {
                $scope.currentPage++;
            }
        };

        $scope.setPage = function (n) {
            $scope.currentPage = n;
        };

        $scope.search = function () {
            $scope.filteredItems = $scope.resultData
            $scope.currentPage = 0;
            $scope.groupToPages();
        };

        $scope.groupToPages = function () {
            $scope.pagedItems = [];
            _.each($scope.filteredItems, function (data) {
                if (data['report'] === "Report Card for VI-VIII (Term - 2)") {
                    data['report'] = "Annual Report"
                }
            })
            for (var i = 0; i < $scope.filteredItems.length; i++) {
                if (i % $scope.itemsPerPage === 0) {
                    $scope.pagedItems[Math.floor(i / $scope.itemsPerPage)] = [$scope.filteredItems[i]];
                } else {
                    $scope.pagedItems[Math.floor(i / $scope.itemsPerPage)].push($scope.filteredItems[i]);
                    //$scope.pagedItems.push($scope.filteredItems[i]);
                }
            }

            if ($scope.pagedItems.length < 11) {
                $scope.gap = $scope.pagedItems.length
            } else {
                $scope.gap = 10
            }
            $scope.limit = $scope.pagedItems.length
        }
        $scope.range = function (size, start, end) {
            var ret = [];
            if (size < end) {
                end = size;
                start = size - $scope.gap;
            }
            for (var i = start; i < end; i++) {
                if (i < $scope.limit) {
                    ret.push(i);
                }
            }
            return ret;
        }

        function csvCovertor(JSONData, reportTitle, showLabel) {
            //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
            var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
            var CSV = '';
            //Set Report title in first row or line
            CSV += reportTitle + '\r\n\n';
            //This condition will generate the Label/Header
            if (showLabel) {
                var row = "";
                //This loop will extract the label from 1st index of on array
                _.each($scope.header, function (header) {
                    row += header + ',';
                })
                row = row.slice(0, -1);
                //append Label row with line break
                CSV += row + '\r\n';
            }

            _.each(arrData, function (data) {
                let row = "";
                _.each($scope.keys, function (key) {
                    row += '"' + data[key] + '",';
                })
                row.slice(0, row.length - 1);
                //add a line break after each row
                CSV += row + '\r\n';
            })

            if (CSV == '') {
                alert("Invalid data");
                return;
            }
            //Generate a file name
            var fileName = "Report_";
            //this will remove the blank-spaces from the title and replace it with an underscore
            fileName += reportTitle.replace(/ /g, "_");

            //Initialize file format you want csv or xls
            var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

            //this trick will generate a temp <a /> tag
            var link = document.createElement("a");
            link.href = uri;

            //set the visibility hidden so it will not effect on your web-layout
            link.style = "visibility:hidden";
            link.download = fileName + ".csv";

            //this part will append the anchor tag and remove it after automatic click
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

        $scope.publishReport = function (ev) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Are you sure to publish?')
                .textContent('Report cards which are approved get published through this action')
                .ariaLabel('Lucky day')
                .targetEvent(ev)
                .ok('Yes')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function () {
            $scope.errorKey = []
            $scope.loading = true
                if ($scope.resultData != undefined && $scope.resultData.length > 0) {
                    let approvedData = _.filter($scope.resultData, function (dt) {
                        return dt.status !== 'approved'
                    })
                    let approvedDataOnly = _.filter($scope.resultData, function (dt) {
                        return dt.status == 'approved'
                    })
                    if (approvedData && approvedData.length) {
                        console.log('there are reportcards of other status also but only approved status will come published')
                    }
                    if (!approvedDataOnly || !approvedDataOnly.length) {
                        toastr.error("there are no approved reports!")
                        $scope.loading = false
                        return false
                    }
                    let requestBody = {
                        args: {
                            ids: _.pluck(approvedDataOnly, "_id"),
                            school_id: school_id,
                            myUserId: localStorageService.get('user_id'),
                            year: localStorageService.get('academic_year')
                        }
                    }
                    authService.callAPI("/v0/reportcards/published/publish", "POST", requestBody, function (response) {
                        try {
							console.log(response,"responserrrrrrrrrrrr")
                            $scope.loading = false
                            $scope.getSelectedFeature(false, self.selected_year);
                            toastr.success("Report published successfully")
                        } catch (ex) {
                            $scope.loading = false
                            console.log(ex);
                        }
                    })
                }
            }, function () {
                $scope.status = 'You decided to cancel.';
            });
        };

        function publishStatusController($scope, $mdDialog, $mdToast, $document, $state, errorMsg, $reactive) {
            $scope.errorMsg = errorMsg;
            $scope.cancel = function () {
                $mdDialog.cancel();
            };
        }
        $scope.saveFilter = function () {
            if ($scope.templateName != undefined) {
                let fields = {}
                let filterObj = {}
                _.each($scope.values, function (dt) {
                    fields[dt.key] = $scope.selectedObj[dt.key]
                    if (dt.selected_text === "Custom") {
                        filterObj[dt.key] = $scope.selectedObj[dt.key]
                    }
                })
                let data = {
                    'creator_id': user_id,
                    'school_id': school_id,
                    'title': $scope.templateName,
                    'fields': fields,
                    'layouts': angular.copy($scope.selectedFilterToShow),
                    'isReportFilter': true,
                    'state': "publishReport"
                }
                authService.callAPI("/v0/reportcards/publish/saveSearch", "POST",
                {filterPage : data}, function (response) {
                    try {
                        $scope.templateName = undefined;
                        $scope.fetchSavedFilter()
                        _.defer(function () { $scope.$apply(); });;
                        toastr.success("Saved search criteria successfully")
                    } catch (ex) {
                        console.log(ex);
                    }
                })
            } else {
                toastr.error('Please enter filter name')
            }
        }

        $scope.displaySavedFilterResult = function (data) {
            if (data != 'None') {
                $scope.selectedFilter = data
                console.log($scope.selectedFilter);
                $scope.selectedFilterToShow = JSON.parse($scope.selectedFilter).layouts
                $scope.header = _.pluck($scope.selectedFilterToShow, "label");
                $scope.keys = _.pluck($scope.selectedFilterToShow, "key");
                $scope.viewFilters(true);
            } else {
                $scope.refreshFilter()
            }
        }

        $scope.transformChip = function (chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }

            // Otherwise, create a new one
            return {
                key: chip,
                label: 'new'
            }
        }

        $scope.autocompleteDemoRequireMatch = true;
        $scope.selectedFilterToShow = []
        $scope.querySearch = function (query) {
            var results = query ? $scope.chipsFilter.filter(createFilterFor(query)) : [];
            return results;
        }


        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(report_field) {
                return (report_field._lowerkey.indexOf(lowercaseQuery) === 0) ||
                    (report_field._lowerlabel.indexOf(lowercaseQuery) === 0);
            };

        }
        $scope.chipRemoveHandler = function (chip) {
            if ($scope.selectedFilterToShow.length <= 2) {
                $scope.isReadOnly = true
            } else {
                $scope.isReadOnly = false
            }
            if ($scope.selectedFilterToShow.length == 0) {
                $scope.header = _.pluck($scope.chipsFilter, "key");
                $scope.keys = _.pluck($scope.chipsFilter, "key");
                _.each($scope.chipsFilter, function (data) {
                    data._lowerkey = data.key.toLowerCase();
                    data._lowerlabel = data.label.toLowerCase();
                    $scope.selectedFilterToShow.push(data)
                })

            } else {
                $scope.header = _.pluck($scope.selectedFilterToShow, "key");
                $scope.keys = _.pluck($scope.selectedFilterToShow, "key");
            }
        }
        $scope.chipAddHandler = function (chip) {
            $scope.header = _.pluck($scope.selectedFilterToShow, "key");
            $scope.keys = _.pluck($scope.selectedFilterToShow, "key");

            if ($scope.selectedFilterToShow.length <= 2) {
                $scope.isReadOnly = true
            } else {
                $scope.isReadOnly = false
            }
        }

        $scope.viewReport = (dataId) => {
            let is_edit = false
            if(self.permissions && self.permissions.Create){
                is_edit = true
            }
            $state.go('viewGeneratedReportData', {
                'dataId': dataId,
                selected_year: self.selected_year,
                is_edit : is_edit
            })
        }


        this.$onDestroy = () => {

        }
    }
}

export default publishReportController;



// WEBPACK FOOTER //
// ./src/app/report_cards/publish_reports/controllers/publishReportController.js